import React from "react"
import _ from "underscore"
import { Check } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import Input from "../input"
import toastr from '@/lib/notifications'

class AddTimes extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      selected_days: [],
      start_time: "08:00",
      end_time: "20:00",
    }
  }

  onSelectDay = (day) => {
    const selected_days = [...this.state.selected_days]

    if (selected_days.includes(day)) {
      const updated_days = selected_days.filter(selectedDay => selectedDay !== day)
      this.setState({ selected_days: updated_days })
    } else {
      this.setState({ selected_days: [...selected_days, day] })
    }
  }

  onChangeStartTime = (start_time) => {
    this.setState({ start_time: start_time })
  }

  onChangeEndTime = (end_time) => {
    this.setState({ end_time: end_time })
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onAdd = () => {
    let times = []

    if(this.state.selected_days.length <= 0) {
      toastr.error('Select day(s).')
      return
    }

    for(const day of this.state.selected_days) {
      let time = {
        day_of_week: day.toLowerCase(),
        timeslots: {
          times: [
            {
              start_time: this.state.start_time,
              end_time: this.state.end_time
            }
          ]
        }
      }

      times.push(time)
    }

    this.props.onAddTimes(times)
  }

  render(){
    const options = [
      { value: 'monday', short_name: 'Mon' },
      { value: 'tuesday', short_name: 'Tue' },
      { value: 'wednesday', short_name: 'Wed' },
      { value: 'thursday', short_name: 'Thu' },
      { value: 'friday', short_name: 'Fri' },
      { value: 'saturday', short_name: 'Sat' },
      { value: 'sunday', short_name: 'Sun' }
    ]

    return (
      <div className="grid gap-4 rounded-[10px] border border-border bg-card p-4">
        <div>
          <div className="text-sm font-semibold">Add New Times</div>
          <span className="text-sm text-muted-foreground">Add multiple times</span>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex flex-wrap items-center gap-1">
            {options.map((option) => {
              const isActive = this.state.selected_days.includes(option.value)

              return (
                <button
                  type="button"
                  key={option.value}
                  onClick={() => this.onSelectDay(option.value)}
                  className={cn(
                    'inline-flex items-center gap-1 rounded-full border px-3 py-1.5 text-sm transition-colors',
                    isActive
                      ? 'border-primary/40 bg-primary/5 text-foreground'
                      : 'border-border bg-card text-muted-foreground hover:bg-muted/50'
                  )}
                >
                  {isActive && <Check className="size-3 text-primary"/>}
                  {option.short_name}
                </button>
              )
            })}
          </div>
          <div className="flex items-center gap-2">
            <Input type="time" value={this.state.start_time} className="cursor-pointer" onChange={this.onChangeStartTime}/>
            <span className="text-muted-foreground">–</span>
            <Input type="time" value={this.state.end_time} className="cursor-pointer" onChange={this.onChangeEndTime}/>
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={this.onCancel}>
            Cancel
          </Button>
          <Button size="sm" onClick={this.onAdd}>
            Save
          </Button>
        </div>
      </div>
    )
  }
}

export default AddTimes
